function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 12C20 13.0506 19.7931 14.0909 19.391 15.0615C18.989 16.0321 18.3997 16.914 17.6569 17.6569C16.914 18.3997 16.0321 18.989 15.0615 19.391C14.0909 19.7931 13.0506 20 12 20C10.9494 20 9.90914 19.7931 8.93853 19.391C7.96793 18.989 7.08601 18.3997 6.34315 17.6569C5.60028 16.914 5.011 16.0321 4.60896 15.0615C4.20693 14.0909 4 13.0506 4 12C4 10.9494 4.20693 9.90914 4.60896 8.93853C5.011 7.96793 5.60028 7.08601 6.34315 6.34315C7.08602 5.60028 7.96793 5.011 8.93853 4.60896C9.90914 4.20693 10.9494 4 12 4C13.0506 4 14.0909 4.20693 15.0615 4.60896C16.0321 5.011 16.914 5.60028 17.6569 6.34315C18.3997 7.08602 18.989 7.96793 19.391 8.93853C19.7931 9.90914 20 10.9494 20 12L20 12Z",
  stroke: "#4E8DD7",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15 12C15 13.0506 14.9224 14.0909 14.7716 15.0615C14.6209 16.0321 14.3999 16.914 14.1213 17.6569C13.8427 18.3997 13.512 18.989 13.1481 19.391C12.7841 19.7931 12.394 20 12 20C11.606 20 11.2159 19.7931 10.8519 19.391C10.488 18.989 10.1573 18.3997 9.87868 17.6569C9.6001 16.914 9.37913 16.0321 9.22836 15.0615C9.0776 14.0909 9 13.0506 9 12C9 10.9494 9.0776 9.90914 9.22836 8.93853C9.37913 7.96793 9.6001 7.08601 9.87868 6.34315C10.1573 5.60028 10.488 5.011 10.852 4.60896C11.2159 4.20693 11.606 4 12 4C12.394 4 12.7841 4.20693 13.1481 4.60896C13.512 5.011 13.8427 5.60028 14.1213 6.34315C14.3999 7.08602 14.6209 7.96793 14.7716 8.93853C14.9224 9.90914 15 10.9494 15 12L15 12Z",
  stroke: "#4E8DD7",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4 12H20",
  stroke: "#4E8DD7",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var SvgLanguage = function SvgLanguage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLanguage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/language.b03f9251.svg";
export { ForwardRef as ReactComponent };